import { ButtonIcon, IconExternalLink } from '@spotify-internal/encore-web';
import { MODULE_STYLES } from '@spotify/confidence-core-react';
import { AttachmentFragment } from '@spotify/confidence-graphql';
import { createArtifactExtension } from '@spotify/plugin-confidence-artifacts-react';

import { IssueArtifactPreview } from '../components/IssueArtifactPreview';
import { issuesPlugin } from '../plugin';

const issueIcon = {
  Icon: MODULE_STYLES.issues.Icon,
  color: MODULE_STYLES.issues.color,
};

const getIssueNavigationPath = (artifact: AttachmentFragment): string =>
  artifact.uri.replace(/^\/\//, '');

export const IssueArtifactExtension = issuesPlugin.provide(
  createArtifactExtension({
    id: 'issue',
    predicate: artifact => /^(?:\/\/)?issues\/[^/]+$/.test(artifact.uri),
    icon: () => issueIcon,
    label: 'Issue',
    category: 'Resources',
    getNavigationPath: getIssueNavigationPath,
    render: artifact => (
      <IssueArtifactPreview issueName={getIssueNavigationPath(artifact)} />
    ),
    renderHeaderActions: artifact => (
      <ButtonIcon
        variant="tertiary"
        onClick={() =>
          window.open(`/${getIssueNavigationPath(artifact)}`, '_blank')
        }
        aria-label="Go to resource"
       data-track-source-anchor="95b04095bb;;low">
        <IconExternalLink  data-track-source-anchor="cfe9f3288f;issue-artifact-extension-icon-external-link"/>
      </ButtonIcon>
    ),
  }),
);
